import React, { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/** Scroll-to-top only — WhatsApp chat is handled by the AiSensy widget in index.html */
export default function FloatingActions() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 320);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed z-[70] bottom-[5.5rem] md:bottom-6 right-3 sm:right-5 flex flex-col items-center gap-3">
      <button
        type="button"
        onClick={scrollTop}
        aria-label="Scroll to top"
        className={`flex items-center justify-center w-12 h-12 rounded-full bg-[#1A2332] text-[#F5EFE6] shadow-[0_10px_28px_rgba(26,35,50,0.28)] hover:bg-[#2c3e5b] transition-all touch-manipulation ${
          showTop ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-2 pointer-events-none'
        }`}
      >
        <ArrowUp className="w-5 h-5" strokeWidth={2.25} />
      </button>
    </div>
  );
}
